/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React, {useState} from 'react';
import { IAbsoluteCheckoutTermsViewProps } from './absolute-checkout-terms';

import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';


export default (props: IAbsoluteCheckoutTermsViewProps) => {


    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);

    const { 
        termsTitle, 
        termsContent
        
           
    } = props;


    return (
        
        <div>

            <Button color="warning" onClick={toggle}>View Terms</Button>
                <Modal isOpen={modal} toggle={toggle} className='ab-terms' >
                    <ModalHeader toggle={toggle}>{termsTitle}</ModalHeader>
                    <ModalBody className="inside-xl">
                        <div>
                            {termsContent}
                        </div>
                    </ModalBody>
                </Modal>
        
        </div>
    );
};
